import { Link } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import { useBranding } from "@/lib/branding";
import { BrandMark } from "@/components/layout/Ambient";
import { Button } from "@/components/ui/button";

export const PrintRow = ({ label, children, testid }) => (
  <div className="grid grid-cols-[200px_1fr] gap-4 py-2 border-b border-slate-200 text-sm break-inside-avoid">
    <div className="text-[11px] uppercase tracking-wider font-semibold text-slate-500 pt-0.5">{label}</div>
    <div className="text-slate-900 whitespace-pre-wrap break-words" data-testid={testid}>{children || "—"}</div>
  </div>
);

export const PrintSheet = ({ back, kind, title, number, children, footer, actions }) => {
  const b = useBranding();
  return (
    <div>
      <div className="flex gap-2 mb-6 print:hidden">
        <Button variant="outline" asChild data-testid="print-back"><Link to={back}><ArrowLeft className="w-4 h-4 mr-1.5" />Back</Link></Button>
        <Button onClick={() => window.print()} data-testid="print-button"><Printer className="w-4 h-4 mr-1.5" />Print / save as PDF</Button>
        {actions}
      </div>
      <article className="force-light bg-white text-slate-900 max-w-[820px] mx-auto border border-slate-300 shadow-sm p-10 print:shadow-none print:border-0 print:p-0 print:max-w-none" data-testid="print-sheet">
        <header className="flex items-start justify-between border-b-4 border-[#0A1633] pb-5">
          <div className="flex items-center gap-3">
            <BrandMark size="w-12 h-12" />
            <div><div className="font-display font-extrabold text-xl tracking-tight">{b.name}</div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500">{b.tagline}</div></div>
          </div>
          <div className="text-right">
            <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500">{kind}</div>
            {number && <div className="font-mono font-bold text-xl mt-1" data-testid="print-number">{number}</div>}
          </div>
        </header>
        <h1 className="mt-6 text-2xl font-bold tracking-tight text-slate-900" data-testid="print-title">{title}</h1>
        <section className="mt-4">{children}</section>
        <footer className="mt-8 pt-3 border-t border-slate-200 text-[10px] text-slate-400 flex justify-between">{footer}</footer>
      </article>
    </div>
  );
};
